import { Box, Grid, TextField } from "@mui/material";
import Field from "components/Field";
import { HexColorPicker } from "react-colorful";
import { MetaValueFieldProps } from "pages/AttributesPage/CustomAttributeComponents/metaValueComponents";

export function ColorPickerField({
  metaValueName,
  index,
  attributeMetaValues,
}: MetaValueFieldProps) {
  const existingValue = attributeMetaValues?.find(
    (m) => m.name === metaValueName,
  )?.value;

  return (
    <>
      <Field
        name={`attributeMetaValues[${index}].name`}
        initialValue={metaValueName}
      >
        {() => null}
      </Field>
      <Field
        name={`attributeMetaValues[${index}].value`}
        initialValue={existingValue ?? ""}
        required
      >
        {({ input, meta }) => (
          <Grid item xs={12}>
            <HexColorPicker color={input.value} onChange={input.onChange} />
            <Box>
              <TextField
                variant="outlined"
                size="small"
                value={input.value}
                onChange={(e) => input.onChange(e.target.value.trim())}
                {...meta}
              />
            </Box>
          </Grid>
        )}
      </Field>
    </>
  );
}
